<!-- /****************************************************************************************************************
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
-->
@if (viewOnly && elementDetail && elementDetail.displayName) {
  <div class="template-title">{{elementDetail.displayName}}</div>
}
@if (templateDraggable) {
  <div class="template-base" draggable="true" (dragstart)="drag($event)">
    @if (viewRef) {
      <div class="action">
        <button mat-icon-button class="delete-button" (click)="removeElement()">
          <mat-icon class="mat-icon-font">delete</mat-icon>
        </button>
      </div>
    }
    <div style="display: flex; flex-direction: row; gap: 16px" class="section">
      <div style="flex: 1 1 25%; max-width: 25%; box-sizing: border-box" class="top-section"> </div>
      <div style="flex: 1 1 25%; max-width: 25%; box-sizing: border-box" class="top-section"> </div>
      <div style="flex: 1 1 25%; max-width: 25%; box-sizing: border-box" class="top-section"> </div>
      <div style="flex: 1 1 25%; max-width: 25%; box-sizing: border-box" class="top-section"> </div>
    </div>
  </div>
}
@if (!templateDraggable) {
  <div class="template-base">
    <div style="display: flex; flex-direction: row; gap: 16px" class="section">
      <div style="flex: 1 1 25%; max-width: 25%; box-sizing: border-box" class="top-section" [ngClass]="viewOnly?'no-border':''" (drop)="dropComponent($event,'box1')"
        (dragover)="allowDrop($event)">
        @if (!viewOnly && !flexibleTemplate && checkNotFixed('box1')) {
          <div class="component-selector">
            <button mat-icon-button class="input-button" (click)="openSelector('box1')">
              <mat-icon class="mat-icon-font">input</mat-icon>
            </button>
          </div>
        }
        <ng-template #box1> </ng-template>
      </div>
      <div style="flex: 1 1 25%; max-width: 25%; box-sizing: border-box" class="top-section" [ngClass]="viewOnly?'no-border':''" (drop)="dropComponent($event,'box2')"
        (dragover)="allowDrop($event)">
        @if (!viewOnly && !flexibleTemplate && checkNotFixed('box2')) {
          <div class="component-selector">
            <button mat-icon-button class="input-button" (click)="openSelector('box2')">
              <mat-icon class="mat-icon-font">input</mat-icon>
            </button>
          </div>
        }
        <ng-template #box2> </ng-template>
      </div>
      <div style="flex: 1 1 25%; max-width: 25%; box-sizing: border-box" class="top-section" [ngClass]="viewOnly?'no-border':''" (drop)="dropComponent($event,'box3')"
        (dragover)="allowDrop($event)">
        @if (!viewOnly && !flexibleTemplate  && checkNotFixed('box3')) {
          <div class="component-selector">
            <button mat-icon-button class="input-button" (click)="openSelector('box3')">
              <mat-icon class="mat-icon-font">input</mat-icon>
            </button>
          </div>
        }
        <ng-template #box3> </ng-template>
      </div>
      <div style="flex: 1 1 25%; max-width: 25%; box-sizing: border-box" class="top-section" [ngClass]="viewOnly?'no-border':''" (drop)="dropComponent($event,'box4')"
        (dragover)="allowDrop($event)">
        @if (!viewOnly && !flexibleTemplate && checkNotFixed('box4')) {
          <div class="component-selector">
            <button mat-icon-button class="input-button" (click)="openSelector('box4')">
              <mat-icon class="mat-icon-font">input</mat-icon>
            </button>
          </div>
        }
        <ng-template #box4> </ng-template>
      </div>
    </div>
  </div>
}


